import type { Product } from '@/productDiscovery/Recommendation/interfaces/product';

export const isSponsoredProduct = (product: Product) =>
  Boolean(
    product &&
      product.isSponsored &&
      product.adTrackingData !== undefined &&
      product.cpc !== undefined &&
      product.position !== undefined,
  );
